import React from "react";
import Typography from "material-ui/Typography";
import Grid from "material-ui/Grid";
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "material-ui/Table";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import Icon from "material-ui/Icon";
import ThumbnailViewer from "../../thumbnails";
import { metersToFeet, dateLongMonthFormatter, dateTimeFormatter } from "../../../../../common/utils";
class SummaryResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAll: false,
      subtestsLT4: [
        { type: "Wiremap", graph: true },
        { type: "Length", graph: false },
        { type: "HeadRoom", graph: false },
        { type: "DelaySkew", graph: false },
        { type: "PropagationDelay", graph: false },
        { type: "Resistance", graph: false },
        { type: "ResistanceUnBalancedPair", graph: false },
        { type: "Impedance", graph: false },
        { type: "Capacitance", graph: false },
        { type: "NEXT", graph: true },
        { type: "PSNEXT", graph: true },
        { type: "ACRF", graph: true },
        { type: "PSACRF", graph: true },
        { type: "ATTEN", graph: true },
        { type: "RTNLOSS", graph: true },
        { type: "ACRN", graph: true },
        { type: "PSACRN", graph: true },
        { type: "TCL", graph: true, cometonly: true },
        { type: "ELTCTL", graph: true, cometonly: true },
        // { type: 'CDNEXT', graph: true, cometonly: true },
        // { type: 'CMRL', graph: true, cometonly: true },
        { type: "TDNEXT", graph: true },
        { type: "TDRTNLOSS", graph: true }
        //  { type: 'TDR', graph: true }
      ],
      subtestsLT3: [
        { type: "Wiremap", graph: true },
        { type: "Length", graph: false },
        { type: "HeadRoom", graph: false },
        { type: "DelaySkew", graph: false },
        { type: "PropagationDelay", graph: false },
        { type: "Resistance", graph: false },
        { type: "Impedance", graph: false },
        { type: "Capacitance", graph: false },
        { type: "NEXT", graph: true },
        { type: "PSNEXT", graph: true },
        { type: "ACRF", graph: true },
        { type: "PSACRF", graph: true },
        { type: "ATTEN", graph: true },
        { type: "RTNLOSS", graph: true },
        { type: "ACRN", graph: true },
        { type: "PSACRN", graph: true },
        { type: "TDNEXT", graph: true },
        { type: "TDRTNLOSS", graph: true }
        //  { type: 'TDR', graph: true }
      ],
      subtestsCoax: [
        { type: "Wiremap", graph: true },
        { type: "Length", graph: false },
        { type: "PropagationDelay", graph: false },
        { type: "Resistance", graph: false },
        { type: "Impedance", graph: false },
        { type: "ATTEN", graph: true },
        { type: "RTNLOSS", graph: true },
        //{ type: "ShieldLocator", graph: true }, //check
        { type: "TDRTNLOSS", graph: true }
      ]
    };
    this.toggleShowAll = this.toggleShowAll.bind(this);
  }

  getTestInfo(results, classes, translate) {
    if (results.data.devicetype === "Comet") {
      return (
        <Grid container className={classes.cometTestInfo}>
        <Grid item xs>
          <span>
            <Typography type="subheading" className={classes.testDetails}>
              <strong>{translate("job_engineer")}</strong>:
              {results.data.engineer}
            </Typography>
            <Typography type="subheading" className={classes.testDetails}>
              <strong>{translate("job_test_adapters")}</strong>:
            </Typography>
            <Typography type="subheading" className={classes.testDetails}>
              {translate("result_main")}: {results.data.maintestadapter}
            </Typography>
            <Typography type="subheading" className={classes.testDetails}>
            {translate("result_remote")}: {results.data.remotetestadapter}
            </Typography>
          </span>
        </Grid>
        <Grid item xs md={3}>
          <Typography type="subheading" className={classes.testDetails}>
            <strong>{translate("job_device")}</strong>:
            {results.data.device}
          </Typography>
          <Typography type="subheading" className={classes.testDetails}>
            <strong>{translate("calibration_date")}</strong>:
          </Typography>
          <Typography type="subheading" className={classes.testDetails}>
            {dateLongMonthFormatter(results.data.calibrationdate)}
          </Typography>
        </Grid>
        <Grid item xs>
          <Typography type="subheading" className={classes.testDetails}>
            <strong>{translate("job_standard")}</strong>:
            {results.data.teststandard
              ? results.data.teststandard
              : results.data.standard
              ? results.data.standard
              : ""}
          </Typography>
          <Typography type="subheading" className={classes.testDetails}>
            <strong>{translate("general_limit")}</strong>:
            {results.data.testlimit}
          </Typography>
        </Grid>
        <Grid item xs>
          <Typography type="subheading" className={classes.testDetails}>
            <strong>{translate("job_link_model")}</strong>:
            {results.data.linkmodel}
          </Typography>
          <Typography type="subheading" className={classes.testDetails}>
            {dateTimeFormatter(results.data.testtime)}
          </Typography>
        </Grid>
        <Grid item xs>
          <Typography type="subheading" className={classes.testDetails}>
            <strong>{translate("job_cable_type")}</strong>:
            {results.data.testedcabletype}
          </Typography>
          <Typography type="subheading" className={classes.testDetails}>
            <strong>{translate("cable_brand")}</strong>:
            {results.data.cablebrand}
          </Typography>
          <Typography type="subheading" className={classes.testDetails}>
              {results.data.cablename}
            </Typography>
            <Typography type="subheading" className={classes.testDetails}>
            Type:{results.data.cableshield}&nbsp;&nbsp;&nbsp;&nbsp;NVP:{results.data.cablenvp}
            </Typography>
        </Grid>
      </Grid>
      );
    }
    else {
      return (
        <Grid container className={classes.testInfo}>
        <Grid item xs>
          <span>
            <Typography type="subheading" className={classes.testDetails}>
              <strong>{translate("job_engineer")}</strong>:
              {results.data.engineer}
            </Typography>
          </span>
        </Grid>
        <Grid item xs md={3}>
          <Typography type="subheading" className={classes.testDetails}>
            <strong>{translate("job_device")}</strong>:
            {results.data.device}
          </Typography>
        </Grid>
        <Grid item xs>
          <Typography type="subheading" className={classes.testDetails}>
            <strong>{translate("job_test_standard")}</strong>:
            {results.data.teststandard
              ? results.data.teststandard
              : results.data.standard
              ? results.data.standard
              : ""}
          </Typography>
        </Grid>
        <Grid item xs>
          <Typography type="subheading" className={classes.testDetails}>
            <strong>{translate("job_link_model")}</strong>:
            {results.data.linkmodel}
          </Typography>
        </Grid>
        <Grid item xs>
          <Typography type="subheading" className={classes.testDetails}>
            <strong>{translate("job_cable_type")}</strong>:
            {results.data.testedcabletype}
          </Typography>
        </Grid>
      </Grid>
      );
    }

  }

  render() {
    const {
      classes,
      translate,
      results,
      job,
      subtest,
      pager,
      getSubtestResults,
      subtestResultsRemote,
      subtestResultsDisplay,
      subtestResultsWiremap,
      chartLineStyle,
      chartMeasurement,
      chartMeasurementUnit,
      wiremapStandard,
      showMargin,
      setPreferences,
      preferences,
      onChangeResultsViewer
    } = this.props;
    let { measurements } = this.getMeasurements();
    const { showAll, subtestsLT3, subtestsLT4, subtestsCoax } = this.state;
    let subtests = subtestsLT4;
  
    if (results) {
      subtests =
        results.data.devicetype === "LantekIII"
          ? subtestsLT3
          : results.data.testedcabletype == "CoaxialCable"
          ? subtestsCoax
          : subtests;
      return (
        <Grid container className={classes.resultsViewer}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {this.getTestInfo(results, classes, translate)}
            <Grid container>
              {subtests.map(test => {
                if (
                  results.data.devicetype === "LantekIII" ||
                  results.data.devicetype === "Comet"
                )
                  return (
                    <ThumbnailViewer
                      translate={translate}
                      subtest={test.type}
                      job={job}
                      graphable={test.graph}
                      results={results}
                      pager={pager}
                      getSubtestResults={getSubtestResults}
                      subtestResultsRemote={subtestResultsRemote}
                      subtestResultsDisplay={subtestResultsDisplay}
                      subtestResultsWiremap={subtestResultsWiremap}
                      chartLineStyle={chartLineStyle}
                      chartMeasurement={chartMeasurement}
                      chartMeasurementUnit={chartMeasurementUnit}
                      wiremapStandard={wiremapStandard}
                      showMargin={showMargin}
                      setPreferences={setPreferences}
                      preferences={preferences}
                      onChangeResultsViewer={onChangeResultsViewer}
                    />
                  );
              })}
            </Grid>
          </Grid>
        </Grid>
      );
    } else {
      return <Typography type="button">No data</Typography>;
    }
  }

  toggleShowAll() {
    this.setState({
      showAll: !this.state.showAll
    });
  }

  getMeasurements() {
    const { results, translate, chartMeasurementUnit } = this.props;
    const subtests = [];
    const measurements = [];
    let val = "";
    if (results) {
      let summaries = [
        ...results.data.subtests,
        ...results.data.othersubtests
      ].sort((x, y) => {
        if (x.order < y.order) return -1;
        if (x.order > y.order) return 1;
        return 0;
      });

      summaries.map(measurement => {
        if (measurement.margin) {
          val = measurement.unit
            ? measurement.margin.value !== null
              ? `${measurement.margin.value} ${measurement.unit}`
              : ""
            : "";
          measurements.push({
            measurement: translate(measurement.subtesttype),
            margin: measurement.margin
              ? `${measurement.margin.margin} ${
                  measurement.unit ? measurement.unit : ""
                } / Pair ${measurement.margin.pair} | ${
                  measurement.margin.handsettype
                }`
              : "",
            value: val,
            subteststatus:
              measurement.subteststatus === "Pass" ? (
                <Icon>check_circle</Icon>
              ) : (
                <Icon>cancel</Icon>
              ),
            show: measurement.isdefault,
            hidden: measurement.hidden
          });
          subtests.push({
            type: measurement.subtesttype
          });
        } else {
          val = measurement.unit
            ? measurement.worst && measurement.worst.value !== null
              ? `${measurement.worst.value} ${measurement.unit}`
              : ""
            : "";
          if (
            measurement.subtesttype === "Length" &&
            chartMeasurementUnit === "feet" &&
            measurement.worst.value
          ) {
            val = metersToFeet(measurement.worst.value);
          }
          measurements.push({
            measurement: translate(measurement.subtesttype),
            margin: measurement.worst
              ? `${
                  measurement.worst && measurement.worst.pair
                    ? `Pair ${measurement.worst.pair}`
                    : ""
                }`
              : "",
            value: val,
            subteststatus:
              measurement.subteststatus === "Pass" ? (
                <Icon>check_circle</Icon>
              ) : (
                <Icon>cancel</Icon>
              ),
            show: measurement.isdefault,
            hidden: measurement.hidden
          });
        }
        return null;
      });
    }
    return {
      measurements,
      subtests
    };
  }
}

export default withStyles(styles)(SummaryResult);



// WEBPACK FOOTER //
// ./src/components/common/results/views/summaryv2/index.js